


import Vue from 'vue'
export default Vue.extend({
  props: {
    value: {
      type: String,
      required: true
    }
  },
  beforeCreate() {
    // @ts-ignore
    this.$fontTransform.run(this.$i18n.vm.messages)
  },
  render() {
    return (
      <div class="default-input">
        <input
          style={this.$t('28PingFangHK400.style')}
          {...{ attrs: { ...this.$attrs } }}
          value={this.value}
          readonly={
            +this.$attrs['component-type'] === 2 || this.$attrs.readonly
          }
          on-input={(e) => this.$emit('input', e.target.value)}
          on-focus={(e) => this.$emit('focus', e)}
          on-blur={(e) => this.$emit('blur', e)}
          on-click={(e) => this.$emit('click', e)}
        />
      </div>
    )
  }
})
